import type { CardType } from '@pushflow/types'
import type { ESuit } from '@pushflow/types/poker/enums'
import { clsx } from 'clsx'
import { useEffect, useState } from 'react'
import { ECardBack, ECardType } from '../../../store/atoms/userSettings'
import {
  cardBackSourceByColor,
  cardClassNameBySuit,
  suitSvgByName,
  suitSymbolByLetter,
} from './constants'
import type { ESuitSymbol } from './enums'
import {
  card,
  cardBackImgStyle,
  cardByTheme,
  colorVarBySuit,
  rank,
  rankWrapper,
  suitBig,
  suitSmall,
} from './index.css'

export const Card = (props: {
  value: CardType | 'null'
  size?: 'sm' | 'md' | 'lg'
  theme?: ECardType
  cardBack?: ECardBack
  style?: React.CSSProperties
  className?: string
}) => {
  const theme = props.theme || ECardType.DEFAULT
  const [value, setValue] = useState<{
    suit: ESuitSymbol | null
    rank: string | null
  }>({
    suit: null,
    rank: null,
  })

  useEffect(() => {
    if (props.value === 'null') {
      return
    }
    const [suit, rank] = props.value
    setValue({
      suit: suitSymbolByLetter[suit as ESuit],
      rank: rank === 'T' ? '10' : rank,
    })
  }, [props.value])

  if (value.suit === null) {
    return (
      <div
        className={clsx(card, props.className)}
        style={props.style}
      >
        <img
          className={cardBackImgStyle}
          src={cardBackSourceByColor[props.cardBack || ECardBack.RED]}
          alt='Back side of a card'
        />
      </div>
    )
  }

  return (
    <div
      className={clsx(
        cardClassNameBySuit[value.suit],
        colorVarBySuit[value.suit],
        cardByTheme[theme],
        props.className,
      )}
      style={props.style}
      aria-details={`A card "${value.rank} ${value.suit}"`}
    >
      <span className={rankWrapper}>
        <span className={rank}>{value.rank}</span>
        <img
          src={suitSvgByName[value.suit]}
          className={suitSmall}
        />
      </span>
      <img
        src={suitSvgByName[value.suit]}
        className={suitBig}
      />
    </div>
  )
}
